import React from 'react';

export const ButtonTabs = props => {
	const tabsItems = props.options.map(option => {
		return (
			<div className="button-tabs__item" key={option.value}>
				<label className={`button-tabs__btn btn ${option.checked ? "btn--primary" : "btn--outline"}`}>
					{option.label}
					<input
						type="radio"
						value="individual"
						style={{ display: 'none' }}
						checked={option.checked}
						onChange={() => props.onChange(option.value)}
					/>
				</label>
			</div>
		);
	});

	return (
		<div className={`${props.className ? props.className : ''} button-tabs`}>{tabsItems}</div>
	);
};